module.exports = __webpack_public_path__ + "img/Shiba-BG.95471c83.jpg";